/**
 * Simple utility to prepend prefixes to field names when they exist,
 * allowing nested form values.
 *
 * Must be used in all `useField` calls and input components where
 * prefixes are used.
 *
 * @param name - Default field name
 * @param prefix - Optional prefix to prepend to the field name
 */
export function getFieldNameWithPrefix(name: string, prefix?: string): string {
  return `${prefix ? `${prefix}.` : ''}${name}`;
}
